module.exports = __webpack_public_path__ + "c234b1f33f59379a9d2dffc5a58a2ef0.ttf";